import '.c4{position:relative;}.ssr-plugin'
import '.j3{width:64px;}.ssr-plugin'
import '.j4{height:64px;}.ssr-plugin'
import '.bn{flex-shrink:0;}.ssr-plugin'
import '.b4{position:absolute;}.ssr-plugin'
import '.j5{bottom:-4px;}.ssr-plugin'
import '.hv{right:-4px;}.ssr-plugin'
import '.cq{border-radius:50%;}.ssr-plugin'
import '.dc{border:2px solid var(--palette-white);}.ssr-plugin'
import '.ag{overflow:hidden;}.ssr-plugin'
import '.j6{width:32px;}.ssr-plugin'
import '.j7{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="c4 j3 j4 bn"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="b4 j5 hv cq dc ag j6 j7"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
